
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class UpdateFranchiseeShareDialog extends Serenity.EntityDialog<ProductFranchiseeShareRow, any> {
        protected getFormKey() { return UpdateFranchiseeShareForm.formKey; }
        protected getIdProperty() { return ProductFranchiseeShareRow.idProperty; }
        protected getLocalTextPrefix() { return ProductFranchiseeShareRow.localTextPrefix; }
        protected getService() { return ProductFranchiseeShareService.baseUrl; }

        protected form = new UpdateFranchiseeShareForm(this.idPrefix);
        public rowids: string;
      
        private checkGrid: ProductFranchiseeShareGrid;
        constructor(gridToRefresh, FormMode, selectedids) {
       
            super();

            this.form = new UpdateFranchiseeShareForm(this.idPrefix);
            //debugger;
            this.rowids = selectedids;
            this.checkGrid = gridToRefresh;
            
        }
        
        loadEntity(entity:ProductFranchiseeShareRow) {
            //debugger;
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            this.form.RowIds.getGridField().toggle(false);

        }

     

       
        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //debugger;
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Updated sucessfully");
                //this.checkGrid.rowSelection.resetCheckedAndRefresh();
                this.checkGrid.refresh();
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            
            buttons.splice(0, 3);
            buttons.push({
                title: 'Update Share',
                cssClass: 'bg-olive',
                 icon: 'fa fa-lock text-green',
                onClick: () => {


                    this.entity.RowIds = this.form.RowIds.value;
                    this.entity.SharingAmount = this.form.SharingAmount.value;
                    
                    //var ProductId = this.form.ProductId;
                    var Id = 1;
                    ProductFranchiseeShareService.UpdateShare({
                        EntityId: Id,
                        Entity: this.entity 
                    }, response => {
                        this.dialogClose();
                        window.location.reload();
                       
                    });


                }
            });
            

            return buttons;
        }


    }
}